import {Formik} from "formik";
import React from "react";
import LanguageFields from "./languages";
import Translate from "../../../utils/utils";

const Form = ({initialValues, createResource, updateResource, isCreatingResource, closeModal, languages, isLoading, isSuccess, moduleName}) => {
    return (
        <Formik
            initialValues={initialValues}

            onSubmit={isCreatingResource() ? createResource : updateResource}
            enableReinitialize={true}
        >
            {({
                  values,
                  status,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
              }) => (
                <form onSubmit={handleSubmit} className="kt-form">
                    {status && (
                        <div role="alert" className={`alert alert-${isSuccess ? 'success' : 'danger'}`}>
                            <div className="alert-text">{status}</div>
                        </div>
                    )}

                    <LanguageFields handleChange={handleChange} isLoading={isLoading} errors={errors}
                                    handleBlur={handleBlur} initialValues={initialValues} languages={languages}
                                    touched={touched} values={values} moduleName={moduleName}/>

                    <div className="kt-add-user__actions">
                        <button
                            type="submit"
                            disabled={isSubmitting || Object.is(initialValues, values)}
                            className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}

                        >
                            {isCreatingResource() ? <Translate id={"DIALOG.FORM.BUTTON.SAVE"}/> :
                                <Translate id={"DIALOG.FORM.BUTTON.UPDATE"}/>}
                        </button>
                        <i
                            onClick={closeModal}
                            className={`btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary`}
                        >
                            <Translate id={"DIALOG.FORM.BUTTON.CLOSE"}/>
                        </i>
                    </div>
                </form>
            )}
        </Formik>
    )
}

export default Form;
